<template>
    <div class="selectable-menu">
        <div v-for="channel in channels" class="option-channels" @click="play(channel.id)">
            <b-progress v-if="showProgressBar && player.channel === channel.id"
                        :value="percentCompleted"
                        :max="100"
                        variant="danger"
                        :id="'channel-progress-' + channel.id"
                        class="channel-progress"
            ></b-progress>

            <div class="song-bar" v-if="player.channel !== channel.id || !player.playing">
                <div class="radio-icon">
                    <svg-icon icon="play_podcast-01"/>
                </div>
                <div class="option-info">
                    <p class="option-name-first">Radio</p>
                    <p class="option-name-second">{{channel.name}}</p>
                </div>
            </div>

            <div class="song-bar" v-if="player.playing && player.channel === channel.id">
                <div class="radio-icon">
                    <img class="album-mob" :src="track.cover" alt="album">
                    <div class="image-overlay"></div>
                </div>
                <div class="radio-icon-pause">
                    <svg-icon icon="pausa_menu_mob"/>
                </div>

                <div class="song-info">
                    <p class="album-name text">{{track.artist}}</p>
                    <p class="song-name text">{{track.title}}</p>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
  import SvgIcon from '../components/layout/SvgIcon'
  import bProgress from 'bootstrap-vue/es/components/progress/progress'

  const socket = new Pusher('ce86a7ca00af7fa6aedb', {
    cluster: 'eu',
    encrypted: true
  })
  const channel = socket.subscribe('radio-status-song')
  
  export default {
    components: {
      SvgIcon,
      bProgress
    },

    data () {
      return {
        player: {
          playing: false,
          id: null,
          channel: 1,
        },
        channels: [],
        track: {
          artist: null,
          title: null,
          cover: null
        },

        percentCompleted: 0,
        showProgressBar: true
      }
    },

    methods: {
      play (channel_id) {
        let audio = document.getElementById('radio-' + channel_id)

        if (this.player.playing && this.player.channel === channel_id) {
          audio.pause()
          this.player.playing = false
        } else {
          let audio_f = document.getElementById('radio-' + this.player.channel)
          audio_f.pause()
          audio.play()
          this.player.playing = true
          this.player.channel = channel_id
          this.goProgressBar()

          this.loadStreamData(channel_id)
        }
      },

      loadStreamData (channel_id) {
        this.$http.get('/api/stream/getInfo/' + channel_id)
          .then(response => {
            this.track = response.data.info
          })
      },

      getAllChannels () {
        this.$http.get('/api/channels')
          .then(response => {
            this.channels = response.data
            if (!Array.isArray(this.channels) || !this.channels.length) {
                return;
            }
            const currentChannelId = this.channels[0].id;
            this.loadStreamData(currentChannelId);
          })
      },

      goProgressBar () {
        this.showProgressBar = true
        this.percentCompleted = 0
        let total = 0,
          self = this

        let id = setInterval(function () {
          if (total > 5000) {
            clearInterval(id)
            self.showProgressBar = false
            self.percentCompleted = 0
          } else {
            total += 250
            self.percentCompleted = Math.round((total * 100) / 5000)
          }
        }, 250)
      },

      listenEvents () {
        let self = this

        channel.bind('end-of-song', function (data) {
          if (!self.player.id && data.track.channel_id == self.player.channel) {
            self.track = data.track
          }
        })
      },
    },
    mounted () {
      this.getAllChannels()
      this.listenEvents()
    }
  }
</script>
<style>
    .channel-progress {
        height: 3px;
        width: 100%;
        position: absolute;
        top: 0;
        z-index: 1000;
    }

    .option-channels {
        position: relative;
    }

    .album-mob {
        max-width: 100%;
        max-height: 100%;
    }

</style>


// WEBPACK FOOTER //
// resources/assets/js/views/Mobile.vue